import React from 'react'
import {FieldWrapper} from './wrapper'
import fieldStyle from './fields.module.css'

export const CheckBox = (props) => {
  let error_message = false
  if(props.error){
    error_message = props.error
  }else if(props.status){
    error_message = props.status
  }
  return(
    <>
    <div className={fieldStyle.checkbox}>
      <input
        type='checkbox'
        id={props.id}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        checked={props.value}
      />
      <p dangerouslySetInnerHTML={{__html:props.checkboxLabel}}/>
    </div>
      {error_message  && props.touched &&
       <div className="formfield__error text-red mt-2">{error_message}</div>
    }
    </>
  )
};
